/* eslint-disable*/
import React from 'react';

export default function AnalyticsNavIcon() {
    return (
        <svg className="analyticsNavIcon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M3.5 18.4898L9.5 12.4798L13.5 16.4798L22 6.91977L20.59 5.50977L13.5 13.4798L9.5 9.47976L2 16.9898L3.5 18.4898Z" fill="white"/>
        </svg>
    );
}



// WEBPACK FOOTER //
// ./src/view/nav/AnalyticsNavIcon.jsx